import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import autoconf from './game/config/autoconf'

import injectTapEventPlugin from 'react-tap-event-plugin'
// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

autoconf()


const rootEl = document.getElementById('root');
ReactDOM.render( <App />,
    rootEl
);


if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render(
        <NextApp />,
        rootEl
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js